<ion-row
  class="accounts-section"
  [class.border]="isAutopay"
  [class.has-rows]="bankAccounts.length > 0"
>
  <ion-accordion
    [class.hide-chevron]="!canCollapseAccordion || bankAccounts.length === 0"
    [readonly]="!canCollapseAccordion || bankAccounts.length === 0"
    [value]="getSectionName()"
  >
    <ion-item slot="header" [class.hide-border]="!isAutopay">
      <div
        class="accounts-header"
        *ngIf="bankAccounts.length > 0; else emptyState"
      >
        <h4 [attr.data-cy]="getSectionName(true) + '-title'">
          {{
            'i18n.payments.paymentPreferences.' + getSectionName() | translate
          }}
        </h4>

        <ion-button
          *ngIf="isEligleAutopayCustomers"
          [attr.data-cy]="getSectionName(true) + '-button'"
          class="usf-fill-green-button"
          (click)="onClickBtn($event)"
        >
          {{
            'i18n.payments.paymentPreferences.' + getSectionName() + 'Action'
              | translate
          }}
          <ion-icon
            *ngIf="isAutopay && !isAutopayEnabled"
            src="assets/icon/external-link-white.svg"
          ></ion-icon>
        </ion-button>
      </div>
      <ng-template #emptyState>
        <app-empty-states
          [title]="
            'i18n.payments.paymentPreferences.' + getSectionName() | translate
          "
          [subtitles]="[
            (isAutopay
              ? 'i18n.payments.paymentPreferences.noAutopayStatement'
              : 'i18n.payments.paymentPreferences.noBankAccountMsg'
            ) | translate,
          ]"
          [buttons]="[
            {
              text:
                (isAutopay
                  ? 'i18n.payments.paymentPreferences.autopayAction'
                  : 'i18n.payments.paymentPreferences.bankAccountsAction'
                ) | translate,
              action: onClickBtn,
              color: 'usf-fill-green-button',
              iconSrc:
                isAutopay && !isAutopayEnabled
                  ? 'assets/icon/external-link-white.svg'
                  : '',
            },
          ]"
        ></app-empty-states>
      </ng-template>
    </ion-item>

    <div *ngIf="bankAccounts.length > 0" slot="content">
      <div class="table-header-container" *ngIf="isDesktop">
        <app-table-header
          [dataColumns]="[
            {
              size: '2.5',
              label: 'i18n.payments.paymentPreferences.customer' | translate,
              sortField: SortFields.customerName,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: getSectionName(true) + '-customer',
            },
            {
              size: '1.7',
              label: 'i18n.payments.paymentPreferences.nickname' | translate,
              sortField: SortFields.nickname,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: getSectionName(true) + '-nickname',
            },
            {
              size: '1.7',
              label: 'i18n.payments.paymentPreferences.bank' | translate,
              sortField: SortFields.bank,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: getSectionName(true) + '-bank-name',
            },
            {
              size: '1.7',
              label:
                'i18n.payments.paymentPreferences.accountNumber' | translate,
              sortField: SortFields.accountNumber,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: getSectionName(true) + '-account-number',
            },
            {
              size: '1.7',
              label:
                'i18n.payments.paymentPreferences.routingNumber' | translate,
              sortField: SortFields.routingNumber,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName: getSectionName(true) + '-routing-number',
            },
            {
              size: '1.4',
              label:
                (isAutopay
                  ? 'i18n.payments.paymentPreferences.startDate'
                  : 'i18n.payments.paymentPreferences.type'
                ) | translate,
              sortField: isAutopay ? SortFields.startDate : SortFields.type,
              sortDirectionByDefault: SortDirection.ASC,
              dataCyName:
                getSectionName(true) +
                '-' +
                (isAutopay ? 'start-date' : 'type'),
            },
          ]"
          [sortField]="sortFilter.fieldName"
          [sortDirection]="sortFilter.sortValue"
          (clickEmit)="handleSort($event)"
        ></app-table-header>
      </div>

      <div class="bank-detail-rows">
        <ng-container *ngIf="isDesktop; else isTouch">
          <app-bank-detail-row-desktop
            *ngFor="let bankDetail of bankAccounts"
            [bankDetail]="bankDetail"
            [isAutopay]="isAutopay"
            (moreOptionsEmit)="openMoreOptions($event)"
          ></app-bank-detail-row-desktop>
        </ng-container>

        <ng-template #isTouch>
          <app-bank-detail-row-touch
            *ngFor="let bankDetail of bankAccounts"
            [bankDetail]="bankDetail"
            [isAutopay]="isAutopay"
            [isMobile]="isMobile"
            (moreOptionsEmit)="openMoreOptions($event)"
          ></app-bank-detail-row-touch>
        </ng-template>
      </div>
    </div>
  </ion-accordion>
</ion-row>
